import React from "react";
import Select from "react-select";

// CustomDropdown Component
const CustomSelectDropdown = ({ options, placeholder, onChange }) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "white",
      borderColor: "#d1d5db", // Tailwind gray-300
      borderWidth: 1,
      boxShadow: "none",
      "&:hover": {
        borderColor: "var(--color--2)", // Tailwind blue-500
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "var(--color--2)" : "white", // Tailwind blue-500
      color: state.isFocused ? "white" : "black",
      padding: 10,
      cursor: "pointer",
      "&:active": {
        backgroundColor: "var(--color--2)", // Tailwind blue-600
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.5rem", // Tailwind rounded-md
      marginTop: "0.5rem",
      zIndex: 100,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
  };

  return (
    <Select
      options={options}
      styles={customStyles}
      placeholder={placeholder || "Select an option"}
      className="basic-single"
      classNamePrefix="select"
      onChange={onChange}
    />
  );
};

export default CustomSelectDropdown;
